import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import * as React from 'react';

import styles from './PanelLoadingState.module.css';

const PanelLoadingState = React.memo(
  (): React.ReactElement => (
    <div className={styles.loadingState} data-testid="panel-loading-state">
      <CobaltLoaderCircular size="large" />
      <p className={`body-02 ${styles.loadingText}`}>
        We're gathering more information.
        <br />
        Please wait a moment or check back shortly.
      </p>
    </div>
  )
);

PanelLoadingState.displayName = 'PanelLoadingState';
export { PanelLoadingState };
